import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable()
@Pipe({
	name: 'cutStringFilter'
})
export class CutStringFilterPipe implements PipeTransform {
	constructor() {}

	transform(value: string, max: number): string {
		if (!value) {
			return '';
		}
		if (value.length <= max) {
			return value;
		}
		value = value.substr(0, max);

		let lastSpace = value.lastIndexOf(' ');
		if (lastSpace !== -1) {
			if (
				value.charAt(lastSpace - 1) === '.' ||
				value.charAt(lastSpace - 1) === ',' ||
				value.charAt(lastSpace - 1) === '!' ||
				value.charAt(lastSpace - 1) === '?'
			) {
				lastSpace -= 1;
			}
			value = value.substr(0, lastSpace);
		}

		return `${value}...`;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./shared/pipes/cut-string/cut-string.ts